import { render, staticRenderFns } from "./reportBusinessAdd.vue?vue&type=template&id=8c93dcd8&scoped=true&"
import script from "./reportBusinessAdd.vue?vue&type=script&lang=js&"
export * from "./reportBusinessAdd.vue?vue&type=script&lang=js&"
import style0 from "./reportBusinessAdd.vue?vue&type=style&index=0&id=8c93dcd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c93dcd8",
  null
  
)

export default component.exports